import { render, staticRenderFns } from "./InputMask.vue?vue&type=template&id=b8c488a6&scoped=true&"
import script from "./InputMask.vue?vue&type=script&lang=ts&"
export * from "./InputMask.vue?vue&type=script&lang=ts&"
import style0 from "./InputMask.vue?vue&type=style&index=0&id=b8c488a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c488a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8c488a6')) {
      api.createRecord('b8c488a6', component.options)
    } else {
      api.reload('b8c488a6', component.options)
    }
    module.hot.accept("./InputMask.vue?vue&type=template&id=b8c488a6&scoped=true&", function () {
      api.rerender('b8c488a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InputMoney/InputMask.vue"
export default component.exports